module.exports = __webpack_public_path__ + "static/WEB1-fb35854a3b7907964ac05631f6ec0dc9.png";